module.exports = __webpack_public_path__ + "img/member_rights_icon_ycq.906c17a8.png";